// eslint-disable-next-line no-unused-vars
import { get, post } from '@/utils/apiBase.js';
// 查看资质
const shopQualification = (option) => {
  return get('/apis/mall/shop_qualification', option);
};
export default {
  shopQualification
};
